export class Charts {
  static SalesOrders = 'SalesOrders';
  static SalesInvoices = 'SalesInvoices';
  static PurchaseOrders = 'PurchaseOrders';
  static PurchaseInvoices = 'PurchaseInvoices';
}
